import { render, staticRenderFns } from "./OpenboxFiscal.vue?vue&type=template&id=6083f4ce&"
import script from "./OpenboxFiscal.vue?vue&type=script&lang=js&"
export * from "./OpenboxFiscal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports